import axios from 'axios';
import { CREATE_COURSE } from '../paths';

export const createCourse = async (courseSteps, courseID) => {
  const body = {
    courseSteps: courseSteps.map(({ _id }) => _id),
    courseID,
  };
  const response = await axios.post(CREATE_COURSE, body);
  return response;
};
